import { render, staticRenderFns } from "./CommonPromotionsTabLinks.vue?vue&type=template&id=27522fee"
import script from "./CommonPromotionsTabLinks.vue?vue&type=script&lang=js"
export * from "./CommonPromotionsTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports